module.exports = __webpack_public_path__ + "static/media/bg.b0c934ef.png";